export const getSearchParam = (search, param) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(param);
};
